import { useCallback } from "react";
import { Form, Formik } from "formik";

import { useDrawerState } from "@hmn/coolinarika-web-core/context/Drawer";
import { md, useBreakpoints, useFormAnalytics } from "@hmn/coolinarika-web-core/hooks";

import { Button, ButtonsCol, buttonSizes, buttonVariants } from "../../../Button";
import { DrawerBody, DrawerFooter } from "../../../Drawer";
import { withErrorBoundary } from "../../../ErrorBoundary";
import { CheckMarkIcon, EraseIcon, Icon } from "../../../Icon";
import { TextField } from "../../../Input/components/TextField";

const TagEdit = () => {
    const [isMobile] = useBreakpoints(md);

    const { content: tag } = useDrawerState();

    const { eventWithTrackingData } = useFormAnalytics({
        trackingData: {
            elementLabel: "Tag edit",
        },
    });

    // Validate form
    const validateForm = (values) => {
        const errors = {};

        if (!values.name) {
            errors.name = "Ime taga ne može biti prazno!";
        }

        return errors;
    };

    const onSubmit = useCallback(
        (values) => {
            eventWithTrackingData();

            // eslint-disable-next-line
            alert('onSubmit' + values)
        },
        [tag, eventWithTrackingData],
    );

    const handleDelete = useCallback(() => {
        // eslint-disable-next-line
        alert('onDelete')
    }, [tag]);

    if (!tag) {
        return null;
    }

    return (
        <Formik
            initialValues={{
                id: tag?.id,
                name: tag?.name,
            }}
            validate={validateForm}
            onSubmit={onSubmit}
        >
            {({ values, errors, handleBlur, handleChange, isSubmitting }) => (
                <Form className="u-formFullHeight" noValidate>
                    <DrawerBody>
                        <TextField
                            label="Naziv taga"
                            name="name"
                            type="text"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!errors.name}
                            errorMessage={errors.name}
                            className="editorForm_field"
                        />
                    </DrawerBody>
                    <DrawerFooter hasSmallSpacing>
                        <ButtonsCol>
                            <Button
                                title="Spremi"
                                type="submit"
                                tag="Spremi"
                                variant={buttonVariants.QUATERNARY}
                                size={buttonSizes.LARGE}
                                sizeMobile={buttonSizes.NORMAL}
                                width="100%"
                                widthMobile="0"
                                disabled={isSubmitting}
                                iconLeftComponent={<Icon icon={CheckMarkIcon} />}
                            >
                                Spremi
                            </Button>
                            <Button
                                title="Obriši tag"
                                tag="Obriši tag"
                                variant={buttonVariants.SECONDARY}
                                size={buttonSizes.NORMAL}
                                onClick={handleDelete}
                                simple={isMobile}
                                iconLeftComponent={<Icon icon={EraseIcon} />}
                            >
                                {isMobile ? "Obriši tag" : "Obriši"}
                            </Button>
                        </ButtonsCol>
                    </DrawerFooter>
                </Form>
            )}
        </Formik>
    );
};

export default withErrorBoundary(TagEdit);
